<template>
    <div class="triton-master-home">
        <div class="tab-hd" v-if="userInfo.isMaster">
            <div
                class="tab-nav"
                v-for="tab in tabs.data"
                :key="tab.value"
                :class="{ active: tabs.active === tab.value }"
                @click="tabs.active = tab.value"
            >
                {{ tab.name }}
            </div>
        </div>
        <div class="tab-bd">
            <div class="tab-page" v-for="tab in tabs.data" v-show="tabs.active === tab.value" :key="tab.value">
                <component
                    v-if="tab.value === 0 || userInfo.isMaster"
                    :ref="'tabViewer-' + tab.value"
                    :is="tab.component"
                    :visible="tabs.active === tab.value"
                    @jumpToTab="jumpToTab"
                />
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import IncomeGeneralization from './components/income-generalization.vue';
import MaterialManagement from './components/material-management.vue';
import WithdrawalRecord from './components/withdrawal-record.vue';

export default {
    name: 'TritonMasterHome',
    data() {
        return {
            tabs: {
                data: [
                    {
                        name: '收益概括',
                        value: 0,
                        component: IncomeGeneralization
                    },
                    {
                        name: '素材管理',
                        value: 1,
                        component: MaterialManagement
                    },
                    {
                        name: '提现记录',
                        value: 2,
                        component: WithdrawalRecord
                    }
                ],
                active: 0
            }
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    methods: {
        jumpToTab(data) {
            this.tabs.active = data.tab;
            let viewer = this.$refs['tabViewer-' + data.tab][0];
            if (viewer && typeof viewer[data.fn] === 'function') {
                viewer[data.fn]();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import './style/triton-master-home.scss';
</style>
